export default __webpack_public_path__ + "static/media/23.574a2a2e.png";